import { useState } from "react";
import { Helmet } from "react-helmet";
import { auth } from "../services/auth";
import Loader from "../shared/Loader";
import { contactUs } from "../services/contact";
import styles from "../css/contact.module.css";

export default function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [order, setOrder] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const token = auth().getToken();
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleMessage = (event) => {
    event.preventDefault();
    if (!name || !email || !subject || !message) {
      // TODO: Display error messages/labels
      return;
    }
    addContatcMessage({
      name: name,
      email: email,
      subject: subject,
      message: message,
    });
  };

  const addContatcMessage = (value) => {
    setIsLoading(true);
    contactUs(value, config)
      .then((response) => {
        if (response.status === 200) {
          setHasError(false);
          setError("Invalid submiting, please try again");
        } else {
          setHasError(true);
        }
      })
      .catch((error) => {
        setHasError(true);
        setError("Internal error, please try again");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <section className="my-20 w-full">
      <Helmet>
        <title>Dailysocialboost | Contact</title>
      </Helmet>
      <h2 className="text-center text-5xl font-bold my-10">Contact Us</h2>
      <h4 className="text-center font-semibold">Have a Question? Get in touch with us.</h4>
      <form
        onSubmit={handleMessage}
        className="flex flex-col items-center align-center align my-10"
      >
        <div className="lg:flex flex-row justify-center gap-x-10 my-1">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="name">
                Your Name
              </label>
            </p>
            <input
              className={`h-8 w-80 ${styles.contactInput}`}
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              name="name"
              id="name"
              required
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="email">
                Email Address
              </label>
            </p>
            <input
              className={`h-8 w-80 ${styles.contactInput}`}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              name="email"
              id="email"
              required
            />
          </div>
        </div>
        <div className="lg:flex flex-row justify-center gap-x-10 my-1">
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="order">
                Order Id <span className="text-gray-450">(OPTIONAL)</span>
              </label>
            </p>
            <input
              className={`h-8 w-80 ${styles.contactInput}`}
              type="text"
              value={order}
              onChange={(e) => setOrder(e.target.value)}
              name="order"
              id="order"
            />
          </div>
          <div>
            <p>
              <label className="uppercase font-semibold" htmlFor="subject">
                Subject
              </label>
            </p>
            <input
              className={`h-8 w-80 ${styles.contactInput}`}
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              name="subject"
              id="subject"
              required
            />
          </div>
        </div>
        <div className="lg:flex flex-col justify-center my-1">
          <div className="flex-none">
            <label className="uppercase font-semibold" htmlFor="message">
              Message
            </label>
          </div>
          <div>
            <textarea
              className={`h-40 w-80 lg:w-84 ${styles.contactMessage}`}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              name="message"
              id="message"
              cols="45"
              rows="5"
            ></textarea>
          </div>
        </div>
        <div className="flex flex-row justify-center my-5">
          <button
            disabled={isLoading}
            className="my-5 px-20 py-3 uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all"
            type="submit"
            value="Submit"
          >
            Submit
          </button>
        </div>
        {isLoading ? (
          <div className="my-5 mx-20 flex flex-row justify-center">
            {" "}
            <Loader styles={"w-12 h-12"}></Loader>{" "}
          </div>
        ) : hasError ? (
          <div
            key={Math.random()}
            className="flex p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400"
            role="alert"
          >
            <svg
              aria-hidden="true"
              className="flex-shrink-0 inline w-5 h-5 mr-3"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clipRule="evenodd"
              ></path>
            </svg>
            <div>
              <span className="font-medium">Error!</span> {error}
            </div>
          </div>
        ) : null}
      </form>
    </section>
  );
}
